/**
 * L'email come la giudica il BROWSER — chiesto al browser, non riscritto.
 *
 * I moduli di autenticazione non hanno `noValidate`, quindi il browser esegue
 * la propria validazione PRIMA di emettere `submit`. Se il cancello che abilita
 * il bottone e il validatore nativo non coincidono, il bottone si abilita su un
 * indirizzo che il browser rifiuta: la sottomissione viene abortita,
 * `handleSubmit` non parte, e nessun messaggio dell'applicazione si accende.
 *
 * ⚠️ Su Chrome e Firefox almeno compare il fumetto nativo («Inserisci un
 * indirizzo email») con lo scroll sul campo. **Safari su iOS non ne disegna
 * nessuno**: il tocco sparisce nel vuoto, ed è l'unica strada in cui quel tasto
 * è letteralmente inerte — solo su Apple.
 *
 * ⚠️ Una regex, anche quella copiata alla lettera dalla specifica, NON basta:
 * il browser fa altro prima di applicarla. Blink converte il dominio in
 * **punycode**, quindi `utente@münchen.de` per lui è valido mentre qualunque
 * regex ASCII lo rifiuta — e chi ha un indirizzo con un dominio
 * internazionalizzato si ritroverebbe il bottone spento per sempre, senza
 * spiegazione. Il primo tentativo di questa riparazione ci era cascato.
 *
 * Un `<input type="email">` staccato dal documento risponde esattamente come il
 * campo vero, sullo stesso motore, conversioni comprese. È esatto per
 * costruzione, e resta esatto se un giorno il browser cambia le regole.
 *
 * Il campo si crea una volta sola e si riusa: non è mai inserito nel documento.
 */
let campoDiProva: HTMLInputElement | null = null;

export function emailAccettataDalBrowser(valore: string): boolean {
  if (!valore) return false;
  /* Fuori da un browser (rendering lato server, strumenti) non c'è nessun
     validatore a cui chiedere: si torna alla domanda più debole, che è comunque
     più prudente di un «sì». */
  if (typeof document === 'undefined') return valore.includes('@');
  if (!campoDiProva) {
    campoDiProva = document.createElement('input');
    campoDiProva.type = 'email';
  }
  campoDiProva.value = valore;
  return campoDiProva.checkValidity();
}
